$(function() {
    $('.flat , .flat-polo').matchHeight();
    $('.grid__item').matchHeight();
});
$(function() {
    $(".slide").slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 2,
        slidesToScroll: 1,
        prevArrow: '<i class="fas fa-long-arrow-left prev"></i>',
        nextArrow: '<i class="fas fa-long-arrow-right next"></i>',
        responsive: [{
                breakpoint: 1024, // 768〜1023px以下のサイズに適用
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 768, // 480〜767px以下のサイズに適用
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 480, // 〜479px以下のサイズに適用
                settings: {
                    slidesToShow: 1,
                    dots: true,
                },
            },
        ],
    });
});
$(function() {
    $('.sd-box ul').slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            }
        }, {
            breakpoint: 480,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            }
        }]
    });
});
$(".slide2").slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow: '<i class="fas fa-long-arrow-left prev"></i>',
    nextArrow: '<i class="fas fa-long-arrow-right next"></i>',
    responsive: [{
            breakpoint: 1024, // 768〜1023px以下のサイズに適用
            settings: {
                slidesToShow: 3,
            },
        },
        {
            breakpoint: 768, // 480〜767px以下のサイズに適用
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 480, // 〜479px以下のサイズに適用
            settings: {
                slidesToShow: 1,
                dots: true,
            },
        },
    ],
});
$(function() {
    $('.code-ds').slick({
        infinite: true,
        prevArrow: '<i class="fas fa-angle-left prev"></i>',
        nextArrow: '<i class="fas fa-angle-right next"></i>',
        slidesToShow: 1,
        slidesToScroll: 1
    });
});
$(function() {
    $(".top-ranking").slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<i class="fas fa-long-arrow-left prev"></i>',
        nextArrow: '<i class="fas fa-long-arrow-right next"></i>',
    });
});
$(function() {
    $("#slider-top").slick({
        initialSlide: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 6000,
        adaptiveHeight: true,
        centerMode: true,
        centerPadding: "15%",
        dots: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        prevArrow: '<span class="material-symbols-outlined prev"> arrow_back_ios_new </span>',
        nextArrow: '<span class="material-symbols-outlined next"> arrow_forward_ios </span>',
        responsive: [{
                breakpoint: 1024, // 768〜1023px以下のサイズに適用
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 768, // 480〜767px以下のサイズに適用
                settings: {
                    initialSlide: 0,
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 480, // 〜479px以下のサイズに適用
                settings: {
                    initialSlide: 0,
                    slidesToShow: 1,
                    dots: true,
                },
            },
        ],
    });
});
$(function() {
    $('.tabnav > li').click(function() {
        $('.tabnav > li,#tab-contents .tab-contentvar2').removeClass('active');
        var tabClass = $(this).attr('class');
        $(this).addClass('active');
        $('#tab-contents .tab-contentvar2').each(function() {
            if ($(this).attr('class').indexOf(tabClass) != -1) {
                $(this).addClass('active').fadeIn();
            } else {
                $(this).hide();
            }
        });
    });
});
$(document).ready(function() {
    $('.slider-sp').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            }
        }, {
            breakpoint: 480,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            }
        }]
    });
    $('.tabnav > li').click(function() {
        $('.slider-sp').slick('setPosition');
    });
});
$(function() {
    $('.slide-shop').each(function() {
        var slideCount = $(this).children('li').length;
        var randomStart = Math.floor(Math.random() * slideCount);
        $(this).slick({
            initialSlide: randomStart,
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<i class="fas fa-caret-square-left prev-cd"></i>',
            nextArrow: '<i class="fas fa-caret-square-right next-cd"></i>',
            autoplay: true,
            autoplaySpeed: 6000,
            rtl: true
        });
    });
});
$(function() {
    $('.slide-shop-sp').each(function() {
        var slideCount = $(this).children('li').length;
        var randomStart = Math.floor(Math.random() * slideCount);
        $(this).slick({
            initialSlide: randomStart,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<i class="fas fa-caret-square-left prev-cd"></i>',
            nextArrow: '<i class="fas fa-caret-square-right next-cd"></i>',
            autoplay: true,
            autoplaySpeed: 6000,
            rtl: true
        });
    });
});
$(function() {
    $(".top-pre").slick({
        initialSlide: 1,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        prevArrow: '<i class="fas fa-long-arrow-left prev"></i>',
        nextArrow: '<i class="fas fa-long-arrow-right next"></i>',
        responsive: [{
                breakpoint: 1024, // 768〜1023px以下のサイズに適用
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 768, // 480〜767px以下のサイズに適用
                settings: {
                    initialSlide: 0,
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 480, // 〜479px以下のサイズに適用
                settings: {
                    initialSlide: 0,
                    slidesToShow: 2,
                },
            },
        ],
    });
});
$(function() {
    $(".top-restock").slick({
        initialSlide: 0,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        prevArrow: '<i class="fas fa-long-arrow-left prev"></i>',
        nextArrow: '<i class="fas fa-long-arrow-right next"></i>',
        responsive: [{
                breakpoint: 1024, // 768〜1023px以下のサイズに適用
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 768, // 480〜767px以下のサイズに適用
                settings: {
                    initialSlide: 0,
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 480, // 〜479px以下のサイズに適用
                settings: {
                    initialSlide: 0,
                    slidesToShow: 2,
                },
            },
        ],
    });
});
var $slide = $(".slide-hk")
    .slick({
        fade: true,
        speed: 2000,
        autoplaySpeed: 5000,
        arrows: false,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true
    });

$(function () {
  $(".sp-tag-area ul").slick({
    slidesToShow: 3,
    arrows: true,
    prevArrow: '<i class="fas fa-caret-square-left prev-cd-tag"></i>',
    nextArrow: '<i class="fas fa-caret-square-right next-cd-tag"></i>',
    adaptiveHeight: true,
    centerMode: true,
    centerPadding: "15%",
    infinite: true,
    variableWidth: true
  });
});